import { Fragment } from 'react';
import PostLink from 'src/modules/shared/links/postLink';
import { truncate } from 'underscore.string';
import { stripBBTags } from 'src/utils/string';
import PostItemFooter from './postItemFooter';

const PostItem = ({
  community,
  post,
  currentUser,
  hideReplies = false,
  isCommunitySearch = false,
  isSearchPost = true,
  onClick = () => {},
}) => {

  if (!post) return null;

  const onPostClick = (type) => {
    onClick(post.postId, type);
  };

  const highlightSearchText = (snippet) => {
    if (!snippet) return null;
    const array = snippet.split('[/b]').map((item, i) => {
      if (item.indexOf('[b]') !== -1) {
        const boldArray = item.split('[b]');
        return [<Fragment key={`highlight-${i}`}>{boldArray[0]}</Fragment>, <b key={`highlight-bold-${i}`}>{boldArray[1]}</b>];
      } else {
        return <Fragment key={`not-highlight-${i}`}>{item}</Fragment>;
      }
    });
    return [].concat(...array);
  };

  const snippet = post.highlight ? highlightSearchText(post.highlight[0]) : stripBBTags(post.bodySnippet);
  const mobileSnippet = post.highlight ? snippet : truncate(snippet, 80);

  return (
    <div className="results-post" key={`p-${post.postId}`} >
      <PostLink
        community={community}
        post={post}
        onClick={() => onPostClick('post')}
      >
        <h3 className="results-post__title">{post.title}</h3>
        <div className="results-post__body hidden-xs">{snippet}</div>
        <div className="results-post__body visible-xs">{mobileSnippet}</div>
      </PostLink>
      <PostItemFooter
        community={community}
        currentUser={currentUser}
        hideReplies={hideReplies}
        isCommunitySearch={isCommunitySearch}
        isSearchPost={isSearchPost}
        post={post}
        onPostClick={onPostClick}
      />
    </div>
  );
};

export default PostItem;
